import { Befehl31FormData, Befehl31FormSchema } from './schema'
import { Befehl31 } from '../../../models'
import {
  Befehl31DataDto,
  BefehlAuftrag_31_10Dto,
  BefehlAuftrag_31_14Dto,
  BefehlAuftrag_31_15Dto,
  Feld_31_11Dto,
  Feld_31_12Dto,
  Feld_31_13Dto,
  Feld_31_16Dto,
  Feld_31_17Dto
} from '../../../dtos/befehl-31-dto'
import { Betriebsstellenart } from '../../../types'
import {
  findAuftragByKennung,
  hasAuftrag,
  createField,
  createSimpleAuftrag,
  filterNullFields
} from '../converter-utils'

export const convertModelToBefehl31FormData = (
  befehl?: Befehl31
): Befehl31FormData => {
  const formData = Befehl31FormSchema.parse({})

  if (!befehl?.auftraege) {
    return formData
  }

  const auftrag31_10 = findAuftragByKennung(
    befehl.auftraege,
    '31.10'
  ) as BefehlAuftrag_31_10Dto

  if (auftrag31_10) {
    const feld31_11 = auftrag31_10.felder?.find(
      (feld) => feld.kennung === '31.11'
    ) as Feld_31_11Dto

    const feld31_12 = auftrag31_10.felder?.find(
      (feld) => feld.kennung === '31.12'
    ) as Feld_31_12Dto

    const feld31_13 = auftrag31_10.felder?.find(
      (feld) => feld.kennung === '31.13'
    ) as Feld_31_13Dto

    const feld31_17 = auftrag31_10.felder?.find(
      (feld) => feld.kennung === '31.17'
    ) as Feld_31_17Dto

    if (feld31_11) {
      formData.auftrag_31_10.feld31_11_12.selector = Betriebsstellenart.Bf
      formData.auftrag_31_10.feld31_11_12.name = feld31_11.werte?.bf ?? ''
    } else if (feld31_12) {
      formData.auftrag_31_10.feld31_11_12.selector = Betriebsstellenart.Bft
      formData.auftrag_31_10.feld31_11_12.name = feld31_12.werte?.bft ?? ''
    }

    if (feld31_13?.werte?.zugmeldestelle) {
      formData.auftrag_31_10.feld31_13 = {
        art: feld31_13.werte.zugmeldestelle.art || '',
        name: feld31_13.werte.zugmeldestelle.name || ''
      }
    }

    if (feld31_17?.werte?.uhrzeit) {
      formData.auftrag_31_10.feld31_17 = feld31_17.werte.uhrzeit
    }
  }

  const has31_14 = hasAuftrag(befehl.auftraege, '31.14')
  const has31_15 = hasAuftrag(befehl.auftraege, '31.15')

  // Set auftrag states based on model
  formData.auftrag31_14 = has31_14
  formData.auftrag31_15 = has31_15

  const auftrag31_15 = findAuftragByKennung(
    befehl.auftraege,
    '31.15'
  ) as BefehlAuftrag_31_15Dto

  if (auftrag31_15) {
    const feld31_16 = auftrag31_15.felder?.find(
      (feld) => feld.kennung === '31.16'
    ) as Feld_31_16Dto
    if (feld31_16?.werte?.nrEinfahrweiche) {
      formData.feld31_16 = feld31_16.werte.nrEinfahrweiche
    }
  }

  return formData
}

export const convertBefehl31FormDataToModel = (
  formData: Befehl31FormData,
  frontendId: string
): Befehl31 => {
  const auftraege: Befehl31DataDto = []

  const { selector, name } = formData.auftrag_31_10?.feld31_11_12 || {}

  const auftrag31_10_fields = filterNullFields([
    selector === Betriebsstellenart.Bf
      ? createField('31.11', { bf: name || '' })
      : null,
    selector === Betriebsstellenart.Bft
      ? createField('31.12', { bft: name || '' })
      : null,
    {
      kennung: '31.13',
      werte: {
        zugmeldestelle: {
          art: formData.auftrag_31_10?.feld31_13?.art || '',
          name: formData.auftrag_31_10?.feld31_13?.name || ''
        }
      }
    },
    {
      kennung: '31.17',
      werte: { uhrzeit: formData.auftrag_31_10?.feld31_17 || '' }
    }
  ])

  auftraege.push({
    kennung: '31.10',
    felder: auftrag31_10_fields
  } as BefehlAuftrag_31_10Dto)

  const simpleAuftrag31_14 = createSimpleAuftrag('31.14', formData.auftrag31_14)
  if (simpleAuftrag31_14)
    auftraege.push(simpleAuftrag31_14 as BefehlAuftrag_31_14Dto)

  if (formData.auftrag31_15) {
    auftraege.push({
      kennung: '31.15',
      felder: [createField('31.16', { nrEinfahrweiche: formData.feld31_16 })]
    } as BefehlAuftrag_31_15Dto)
  }

  return {
    kennung: '31',
    frontendId,
    auftraege
  }
}
